const ProductSpanSelector = {
  root: document.querySelector("[data-product-span-selector]"),
  buttons: document.querySelectorAll("[data-product-span-selector-button]"),
  grid: document.querySelector(".section-list-products .list-products"),
  validValues: ["2", "4", "8"],
  defaultValue: "4",
  storageKey: "tag:grid-product-span",

  normalizeSpan: function (value) {
    return ProductSpanSelector.validValues.includes(value)
      ? value
      : ProductSpanSelector.defaultValue;
  },

  getStoredSpan: function () {
    try {
      const storedSpan = window.localStorage.getItem(
        ProductSpanSelector.storageKey,
      );

      return ProductSpanSelector.normalizeSpan(storedSpan);
    } catch (error) {
      return ProductSpanSelector.defaultValue;
    }
  },

  saveSpan: function (value) {
    const span = ProductSpanSelector.normalizeSpan(value);

    try {
      window.localStorage.setItem(ProductSpanSelector.storageKey, span);
    } catch (error) {
      return;
    }
  },

  setGridSpan: function (value) {
    const span = ProductSpanSelector.normalizeSpan(value);

    if (!ProductSpanSelector.grid) return;

    ProductSpanSelector.grid.setAttribute("data-product-span", span);

    ProductSpanSelector.syncActiveButton(span);
  },

  syncActiveButton: function (value) {
    if (!ProductSpanSelector.buttons.length) return;

    ProductSpanSelector.buttons.forEach((button) => {
      const isActive = button.dataset.productSpanSelectorButton === value;

      button.classList.toggle("-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  },

  bindEvents: function () {
    if (!ProductSpanSelector.buttons.length) return;

    ProductSpanSelector.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const value = button.dataset.productSpanSelectorButton;

        ProductSpanSelector.setGridSpan(value);
        ProductSpanSelector.saveSpan(value);
      });
    });
  },

  init: function () {
    const { root, grid } = ProductSpanSelector;

    if (!root || !grid || window.mobile) return;

    const storedSpan = ProductSpanSelector.getStoredSpan();

    ProductSpanSelector.setGridSpan(storedSpan);
    ProductSpanSelector.bindEvents();
  },
};

export default ProductSpanSelector;
